import React from 'react';
import { Box, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  titleContainer: {
    height: '58px',
    padding: '20px 16px'
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    color: '#212121',
    marginBottom: '0rem'
  },
  content: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));

export const PanelHeader = props => {
  const { title, content } = props;
  const classes = useStyles();
  return (
    <div className={classes.titleContainer}>
      <Grid container spacing={1}>
        <Grid item xs={6} sm>
          <h5 className={classes.title}>{title}</h5>
        </Grid>
        {content && (
          <Grid item xs={6} sm>
            <Box className={classes.content}>{content}</Box>
          </Grid>
        )}
      </Grid>
    </div>
  );
};
